import React from "react";
import { CreditsLogParsed } from "../../../../models";
import { Table } from "antd";

export interface ILogListProps {
  log: CreditsLogParsed[];
  emptyLogText?: string;
  loading: boolean;
  columns: { title: string, dataIndex: string, key: string }[];
}

const LogList = (props: ILogListProps) => {
  const {
    log,
    emptyLogText,
    loading,
    columns,
  } = props;

  return (
    log && log.length > 0 ? (
      <Table
        loading={loading}
        dataSource={log}
        columns={columns}
        pagination={false}
        size="small"
      />
    ) : (
      <p>{emptyLogText}</p>
    )
  );
};

LogList.defaultProps = {
  log: null,
};

export default LogList;



// WEBPACK FOOTER //
// ./src/routes/Admin/Log/LogList/index.tsx